<div class="http-error-page__container">
  <div class="http-error-page__content">
    <h1 class="http-error-page__header">
      Oh! That's unfortunate...
    </h1>
    <h2 class="http-error-page__reason">
      403... Your Access is denied
    </h2>
    <div class="http-error-page__solution">
      <span class="http-error-page__solution-text">Please contact support if you think it's a mistake</span>
    </div>
    <div class="http-error-page__go-back-link" (click)="goBack()">
      <span class="http-error-page__go-back-link-text">Go Back</span>
    </div>
  </div>
</div>